window.DS24 = window.DS24 || {};

window.DS24_CONFIG = {

    apiUrl: "https://qbxdigi24.it.com/products/digistore/id/",

    continueUrl: "/collections/alle-produkte",

    freeGiftId: 692121,

    freeGiftThreshold: 100,

    freeGiftTiers: [
        { id: 711546, threshold: 100 },
        { id: 711279, threshold: 200 },
    ]
};

DS24.helpers = (() => {

    function getParam(name) {

        const hash = window.location.hash.replace('#', '');

        const hashParams = new URLSearchParams(hash);

        const queryParams = new URLSearchParams(
            window.location.search
        );

        return (
            hashParams.get(name) ||
            queryParams.get(name)
        );
    }

    function setCookie(name, value) {

        document.cookie =
            `${name}=${encodeURIComponent(value)}; path=/; max-age=${30 * 86400}`;
    }

    function getCookie(name) {

        const match = document.cookie.match(
            new RegExp(
                '(?:^|; )' + name + '=([^;]*)'
            )
        );

        return match
            ? decodeURIComponent(match[1])
            : null;
    }

    function persist(name, value) {

        if (!value) {
            return;
        }

        setCookie(name, value);

        try {

            localStorage.setItem(name, value);

        } catch (e) {}
    }

    function getPersisted(name) {

        return (
            getCookie(name) ||
            localStorage.getItem(name) ||
            ""
        );
    }

    function updateBubble(quantity) {

        const bubble = document.querySelector(
            ".cart-count-bubble"
        );

        if (!bubble) {
            return;
        }

        if (quantity > 0) {

            bubble.innerText = quantity;

            bubble.classList.remove("hidden");

        } else {

            bubble.classList.add("hidden");
        }
    }

    function animateCartIcon() {
        const icon = document.querySelector('.ds-cart-icon');

        if (!icon) return;

        icon.classList.remove('bump');

        void icon.offsetWidth;

        icon.classList.add('bump');

        icon.addEventListener('animationend', () => {
            icon.classList.remove('bump');
        }, { once: true });
    }

    function getQuantity() {

        const qty = document.querySelector(
            'input[name="quantity"]'
        );

        return qty
            ? Math.max(
                1,
                parseInt(qty.value || 1)
            )
            : 1;
    }

    function getShopifyProductId() {

        return (
            window?.meta?.product?.id ||
            document.querySelector('[data-product-id]')
                ?.dataset?.productId ||
            null
        );
    }

    function getDigistoreId(btn) {

        const input = btn.closest("form")
            ?.querySelector('[name="digistore-id"]');

        const val = input?.value?.trim();

        return (
            val &&
            val !== "0" &&
            val !== "none"
        )
            ? val
            : null;
    }

    async function resolveDigistoreId(productId) {

        const res = await fetch(
            DS24_CONFIG.apiUrl + "?id=" + productId
        );

        const data = await res.json();

        return data?.digistore_id || null;
    }

    /*
    |--------------------------------------------------------------------------
    | TRACKING INIT
    |--------------------------------------------------------------------------
    */

    const affiliate = getParam("aff");

    const campaignkey =
        getParam("campaignkey") ||
        getParam("cam");

    const trackingkey =
        getParam("trackingkey");

    if (affiliate) {
        persist("ds24_affiliate", affiliate);
    }

    if (campaignkey) {
        persist("ds24_campaignkey", campaignkey);
    }

    if (trackingkey) {
        persist("ds24_trackingkey", trackingkey);
    }

    window.ds24_affiliate =
        getPersisted("ds24_affiliate") || '';

    window.ds24_campaignkey =
        getPersisted("ds24_campaignkey") || '';

    window.ds24_trackingkey =
        getPersisted("ds24_trackingkey") || '';

    return {
        getQuantity,
        getShopifyProductId,
        getDigistoreId,
        resolveDigistoreId,
        updateBubble,
        animateCartIcon,
        getPersisted,
    };

})();